import { buildUrl, encodeSectionsBaseUrl, ok } from "../../utils/util";
import createAxiosInstance from "../LambdaApiAdministracion";
import { ENVIROMENT } from "../../utilities";

const SECTION_BASE_URL = ENVIROMENT === "dev"? "inventario/productos" : "home/inventario/productos";
const SECTION_BASE_URL_2 = ENVIROMENT === "dev"? "inventario/productos-almacenes" : "home/inventario/productos-almacenes";
const SECTION_BASE_URL_IMAGE = ENVIROMENT === "dev"? "inventario/productos-imagen" : "home/inventario/productos-imagen";

const SearchProducts = async ({ brand, ceco, term }, { page = 0, size = 10 } = {}) => {
  if (!brand) {
    throw new Error("⚠️ El parámetro 'brand' es requerido");
  }

  if (!term) {
    throw new Error("⚠️ El parámetro 'term' es requerido");
  }

  if (!ceco) {
    // eslint-disable-next-line no-console
    console.warn("El parámetro 'ceco' es requerido");
    throw new Error("⚠️ El parámetro 'ceco' es requerido");
  }

  const axiosInstance = await createAxiosInstance();

  const encodedUrl = encodeSectionsBaseUrl(`${SECTION_BASE_URL}/marca`, brand);
  const url = `${encodedUrl}/buscar`;

  const params = { texto: term, page, size };
  //? envio de ceco
  // const params = { texto: term, ceco, page, size };

  const requestConfig = {
    method: "GET",
    url,
    params,
    headers: { Accept: "application/json" },
  };

  try {
    const res = await axiosInstance(requestConfig);
    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al buscar productos");
  }
};

const GetProducts = async ({ brand, branchFiSucursalId }, { page = 0, size = 10 } = {}) => {
  if (!brand) {
    // eslint-disable-next-line no-console
    console.warn("El parámetro 'brand' es requerido");
    throw new Error("⚠️ El parámetro 'brand' es requerido");
  }

  if (branchFiSucursalId == null) {
    // eslint-disable-next-line no-console
    console.warn("El parámetro 'branchFiSucursalId' es requerido1");
    throw new Error("⚠️ El parámetro 'branchFiSucursalId' es requerido1");
  }

  const axiosInstance = await createAxiosInstance();

  const url = encodeSectionsBaseUrl(`${SECTION_BASE_URL}/marca`, brand);

 // const params = { page, size, ceco };
  //? envio de ceco
  const params = { ceco:branchFiSucursalId, page, size };

  const requestConfig = {
    method: "GET",
    url,
    params,
    headers: { Accept: "application/json" },
  };

  try {
    const res = await axiosInstance(requestConfig);
    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al obtener productos");
  }
};

const GetProductsByStoreId = async ({ brand, branchFiSucursalId, storeId }, { page = 0, size = 10 } = {}) => {
  if (!brand) {
    throw new Error("⚠️ El parámetro 'brand' es requerido");
  }

  if (branchFiSucursalId == null) {
    throw new Error("⚠️ El parámetro 'branchFiSucursalId' es requerido2");
  }

  if (!storeId) {
    throw new Error("⚠️ El parámetro 'storeId' es requerido");
  }

  const axiosInstance = await createAxiosInstance();

  const url = buildUrl(`${SECTION_BASE_URL}/marca/:marca/almacen/:idAlmacen`, {
    marca: brand,
    idAlmacen: storeId,
  });

  const params = { ceco:branchFiSucursalId, page, size };

  const requestConfig = {
    method: "GET",
    url,
    params,
    headers: { Accept: "application/json" },
  };

  try {
    const res = await axiosInstance(requestConfig);
    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al obtener productos");
  }
};

const UpdateProductImage = async (id, brand, imageBody) => {
  if (!id) throw new Error("Id es requerido");
  if (!brand) throw new Error("Marca es requerida");

  if (
    !imageBody ||
    typeof imageBody.fileName !== "string" ||
    typeof imageBody.base64 !== "string" ||
    typeof imageBody.contentType !== "string"
  ) {
    throw new Error("ImageBody es incorrecto");
  }

  const axiosInstance = await createAxiosInstance();

  const url = `${SECTION_BASE_URL_IMAGE}/subir`;

  const params = { idProducto: id, marca: brand };

  const requestConfig = {
    method: "POST",
    url,
    params,
    data: imageBody,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axiosInstance(requestConfig);

    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al actualizar la imagen del producto");
  }
};

const DeleteProductImage = async (productId) => {
  if (!productId) throw new Error("Id de producto es requerido");

  const axiosInstance = await createAxiosInstance();

  const url = `${SECTION_BASE_URL_IMAGE}/eliminar/${productId}`;

  const requestConfig = {
    method: "DELETE",
    url,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axiosInstance(requestConfig);
    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al eliminar la imagen del producto");
  }
};

const AddProductToSection = async (productId, storesId) => {
  const axiosInstance = await createAxiosInstance();

  const url = `${SECTION_BASE_URL_2}/asignar`;

  const data = {
    idProducto: productId,
    almacenIds: storesId,
  };

  const requestConfig = {
    method: "POST",
    url,
    data,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };

  try {
    const res = await axiosInstance(requestConfig);

    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al asignar el producto al almacen");
  }
};

const RemoveProductFromStore = async (productId, storeId) => {
  const axiosInstance = await createAxiosInstance();

  const url = `${SECTION_BASE_URL_2}/desasignar`;

  const params = {
    idProducto: productId,
    idAlmacen: storeId,
  };

  const requestConfig = {
    method: "DELETE",
    url,
    params,
    headers: { Accept: "application/json" },
  };

  try {
    const res = await axiosInstance(requestConfig);
    return ok(res.data);
  } catch (err) {
    throw new Error(err?.message || "Error al eliminar el producto del almacen");
  }
};

export const productsService = {
  getAll: GetProducts,
  getByStoreId: GetProductsByStoreId,
  search: SearchProducts,
  updateImage: UpdateProductImage,
  deleteImage: DeleteProductImage,
  addToStore: AddProductToSection,
  removeFromStore: RemoveProductFromStore,
};
